export const fileUploadConfig = {
    "allowedImageFormats": [
        {
            "extension": ".gif",
            "mime": "image/gif"
        },
        {
            "extension": ".jpg",
            "mime": "image/jpeg"
        },
        {
            "extension": ".jpeg",
            "mime": "image/jpeg"
        },
        {
            "extension": ".jfif",
            "mime": "image/jpeg"
        },
        {
            "extension": ".tiff",
            "mime": "image/tiff"
        },
        {
            "extension": ".tif",
            "mime": "image/tiff"
        },
        {
            "extension": ".png",
            "mime": "image/png"
        },
        {
            "extension": ".svg",
            "mime": "image/svg+xml"
        },
    ],
    "allowedPdfFormats": [
        {
            "extension": ".pdf",
            "mime": "application/pdf"
        },
    ],
    "allowedMimeTypes": [
        {
            "extension": ".csv",
            "mime": "text/csv"
        },
        {
            "extension": ".doc",
            "mime": "application/msword"
        },
        {
            "extension": ".docx",
            "mime": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        },
        {
            "extension": ".gif",
            "mime": "image/gif"
        },
        {
            "extension": ".jpg",
            "mime": "image/jpeg"
        },
        {
            "extension": ".jpeg",
            "mime": "image/jpeg"
        },
        {
            "extension": ".odc",
            "mime": "application/x-vnd.oasis.opendocument.chart"
        },
        {
            "extension": ".odc",
            "mime": "application/vnd.oasis.opendocument.chart"
        },
        {
            "extension": ".pdf",
            "mime": "application/pdf"
        },
        {
            "extension": ".png",
            "mime": "image/png"
        },
        {
            "extension": ".ppt",
            "mime": "application/vnd.ms-powerpoint"
        },
        {
            "extension": ".pptx",
            "mime": "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        },
        {
            "extension": ".rtf",
            "mime": "application/rtf"
        },
        {
            "extension": ".svg",
            "mime": "image/svg+xml"
        },
        {
            "extension": ".txt",
            "mime": "text/plain"
        },
        {
            "extension": ".xls",
            "mime": "application/vnd.ms-excel"
        },
        {
            "extension": ".xlsx",
            "mime": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        {
            "extension": ".dwg",
            "mime": "image/x-dwg"
        },
        {
            "extension": ".jfif",
            "mime": "image/jpeg"
        },
        {
            "extension": ".tiff",
            "mime": "image/tiff"
        },
        {
            "extension": ".tif",
            "mime": "image/tiff"
        },
    ],
    "unsupportedDocViewerMimeTypes" : [
        {
            "extension": ".rtf",
            "mime": "application/rtf"
        },
        {
            "extension": ".dwg",
            "mime": "image/x-dwg"
        }
    ],
    "maxFileSizeInMB": 10
}